import { render } from "./KioskAdminPage.vue?vue&type=template&id=5d45ad58&scoped=true"
import script from "./KioskAdminPage.vue?vue&type=script&lang=js"
export * from "./KioskAdminPage.vue?vue&type=script&lang=js"

import "./KioskAdminPage.vue?vue&type=style&index=0&id=5d45ad58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d45ad58"]])

export default __exports__